import styled from "@emotion/styled";
import { Switch, SwitchProps, Typography } from "@mui/material";

const NormalSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#1B88CC',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#1B88CC',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:  "#f7f7f7"
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
    },
  }));

const LargeSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(() => ({
    width: 72,
    height: 40,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(32px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor:  '#1B88CC',
          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#1B88CC',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: "#f7f7f7"
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7 ,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 35,
      height: 35,
    },
    '& .MuiSwitch-track': {
      borderRadius: 46 / 2,
      backgroundColor: '#E9E9EA' ,
      opacity: 1,
    },
  }));

export const CustomizedSwitch = (props: SwitchProps, showStatus: boolean) => {
  switch(props.size){
    case 'small':
        return <><NormalSwitch {...props}/></>
    case 'medium':
        return <><LargeSwitch {...props}/></>
    default: 
        return <><NormalSwitch {...props}/></> 
  }
};
